import * as z from "zod";

const LocalizationTextOverrideSchema_ = z.object({
  _id: z.string(),
  localizationGroupId: z.string(),
  localizationObjectId: z.string(),
  path: z.string(),
  text: z.string(),
});

const LocalizationTextOverrideSchema: z.ZodType<LocalizationTextOverrideSchema> =
  LocalizationTextOverrideSchema_;
export interface LocalizationTextOverrideSchema extends z.infer<
  typeof LocalizationTextOverrideSchema_
> {}

const WidgetInfoSchema_ = z.object({
  name: z.string(),
  localizationId: z.string(),
  elementType: z.string(),
});

const WidgetInfoSchema: z.ZodType<WidgetInfoSchema> = WidgetInfoSchema_;
export interface WidgetInfoSchema extends z.infer<typeof WidgetInfoSchema_> {}

export const LocalizationTextOverridesOutputSchema = z.object({
  activeTextFields: z
    .array(z.object({ localizationObjectId: z.string(), path: z.string() }))
    .optional(),
  defaultTextOverrides: z
    .array(
      z.object({
        localizationObjectId: z.string(),
        path: z.string(),
        text: z.string(),
      }),
    )
    .optional(),
  widgetInfo: z.array(WidgetInfoSchema),
  localizationTextOverrides: z.array(LocalizationTextOverrideSchema),
});
